import axios from 'axios';
import { trimStringForQuery } from 'utils/utils';

const API_URL = '/api/v1/call-center/';
const CREATE = 'create';
const DELETE = 'delete';
const SEARCH = 'search';
// eslint-disable-next-line
const DELETE_REP_LIST = 'deletereplist/';
const CALLCENTER_LIST_PAGINATION = 'callcenter-list';
const ALL = 'all';


const searchContactCenters = async ({ filterQuery, pageIndex, pageSize, sortBy }) => {
	return await axios.post(`${API_URL}${SEARCH}`, {
		page: pageIndex,
		count: pageSize,
		sortBy,
		include: [
			"name",
		],
		filters: [
			{
				type: 'string',
				name: 'name',
				value: trimStringForQuery(filterQuery),
				exactMatch: false,
			},
		],
	});
};

const getContactCenters = async ({
	filterQuery,
	pageIndex,
	pageSize,
} = {}) => {
	return await axios.get(`${API_URL}${CALLCENTER_LIST_PAGINATION}`, {
		params: {
			pagination: JSON.stringify({ page: pageIndex, count: pageSize }),
			filter: JSON.stringify({ name: trimStringForQuery(filterQuery) }),
		},
	});
};

const getContactCentersList = () => {
	return axios.get(`${API_URL}${ALL}`);
};

const updateContactCenter = ({
	callCenterId,
	name,
	validVerbiage,
	fraudVerbiage,
	orList,
	active,
	timer,
	deleteList,
	isFraudVerbiageChanged,
	isFraudLogoChanged,
	isVerifiedLogoChanged,
	createdBy,
	modifiedBy,
	verifiedImage,
	fraudImage,
	smsImage,
	startOfWork,
	endOfWork,
	timeZone,
}) => {
	const formData = new FormData();
	formData.append('data', JSON.stringify({
		callCenterId,
		name,
		validVerbiage,
		fraudVerbiage,
		orList,
		active,
		timer,
		deleteList,
		isFraudVerbiageChanged,
		isFraudLogoChanged,
		isVerifiedLogoChanged,
		createdBy,
		modifiedBy,
		startOfWork,
		endOfWork,
		timeZone,
	}));

	verifiedImage && formData.append('verifiedImage', verifiedImage);
	fraudImage && formData.append('fraudImage', fraudImage);
	smsImage && formData.append('smsImage', smsImage);

	return axios.post(`${API_URL}${CREATE}`,
		formData,
		{
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		}
	);
};

const deleteContactCentersList = async (selected) => {
	return await axios.delete(`${API_URL}${DELETE}`, {
		data: { deleteIds: selected },
	});
};

const getDetails = async (id) => {
	return await axios.get(`${API_URL}${id}`);
};

const getContactCenterImage = (id, imageType) => {
	return axios.get(`${API_URL}${id}/download-image?imageType=${imageType}&timeStamp=${Date.now()}`,
		{
			responseType: 'blob',
		});
}

export {
	searchContactCenters,
	getContactCenters,
	deleteContactCentersList,
	updateContactCenter,
	getDetails,
	getContactCentersList,
	getContactCenterImage,
};
